/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { KeyType } from '../../models/key-type';
import { VoiceResult } from '../../models/voice-result';

export interface PostVoiceSessionResult$Params {
  organizationSiteKey: KeyType;
  voiceSessionKey: KeyType;
      body: VoiceResult
}

export function postVoiceSessionResult(http: HttpClient, rootUrl: string, params: PostVoiceSessionResult$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, postVoiceSessionResult.PATH, 'post');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.path('voiceSessionKey', params.voiceSessionKey, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

postVoiceSessionResult.PATH = '/organization-sites/{organizationSiteKey}/voice-sessions/{voiceSessionKey}/result';
